const bp = {
  small: "@media (max-width: 450px)",
  medium: "@media (max-width: 768px)",
  large: "@media (max-width: 1170px)",
  verylarge: "@media (max-width: 1400px)",
};
export default bp;
